<template>
	<div class="service-switch">
		<button type="button" :class="btn.classes" @click="switchService(btn.id)" v-for="btn in buttons" :key="`btn-${btn.id}`">
			{{ $t(btn.buttonTextKey) }}
		</button>
	</div>
</template>

<script>
	export default {
		name: 'ServiceSwitch',
		methods: {
			switchService(service) {
				this.$router.push({ name: service })
			}
		},
		data () {
			return {
				btns: [
					{
						id: 'home',
						buttonTextKey: 'appName',
						classes: {
							'btn-service-switch': true,
							'is-active': false
						}
					},
					{
						id: 'companies',
						buttonTextKey: 'services',
						classes: {
							'btn-service-switch': true,
							'is-active': false
						}
					},
					{
						id: 'buy-card',
						buttonTextKey: 'buyCard',
						classes: {
							'btn-service-switch': true,
							'is-active': false
						}
					}
				]
			}
		},
		computed: {
			buttons () {
				let res = []

				this.btns.forEach(btn => {
					if (btn.id === this.$route.name) {
						btn.classes['is-active'] = true
					} else {
						btn.classes['is-active'] = false
					}

					res.push(btn)
				})

				return res
			}
		}
	}
</script>

<style lang="scss" scoped>
	.service-switch{
		display: flex;
		justify-content: space-between;
		align-items: center;
		max-width: rem-calc(450);
		margin: 0 auto;

		.btn-service-switch{
			cursor: pointer;
			position: relative;
			padding-top: .25rem;
			padding-bottom: .25rem;

			&:first-child {
				margin-left: .5rem;
			}
			&:last-child {
				margin-right: .5rem;
			}


			&.is-active:after {
				content: '';
				display: inline-block;
				height: 4px;
				width: 105%;
				margin: 0 auto;

				position: absolute;
				bottom: -1.20rem;
				left: -.125rem;
				right: 0;

				border-radius: 5rem;
				background-color: get-color(primary);
			}
		}
	}
</style>